import { render, staticRenderFns } from "./ViewTarget.vue?vue&type=template&id=0a39ac42&"
import script from "./ViewTarget.vue?vue&type=script&lang=js&"
export * from "./ViewTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports